export const MODULES_TOKEN = 'MODULES';

export const MODULES_API_PATHS = {
};
